<template>
  <v-layout
    align-center
    justify-center
  >
    
      <h3>You are logged out</h3>
   
  </v-layout>
</template>


<script>  

export default {
    data(){
        return {
            email:null,
            password:null
        };
    },

    created(){
        Bus.$emit("logout");
        this.$store.dispatch("logout");
        setTimeout(() => {
          this.$store.dispatch("adminLogin"); // goto loginscreen after 3 seconds.
        }, 3000);
    }
};

</script>

